<template>
  <div class="form-input" :class="{'error': allErrors.length }">
    <label
        v-if="title !== undefined"
        class="label mb-xxs"
        :class="{'disabled': disabled}"
        :for="title"
    >
      {{ title }}
      {{ isRequired ? '*' : '' }}
    </label>
    <slot :validateInput="validateInput"></slot>
    <div v-if="allErrors.length > 0" class="flex-col gap-xxs">
      <small
          v-for="(error, idx) in allErrors"
          :key="idx"
          class="error-message"
      >
        {{ error }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: "DdInputWrapper",
  props: {
    value: {
      type: [String, Array, Number, Object, Boolean],
      required: false
    },
    title: {
      type: String,
      required: false
    },
    rules: {
      type: [String, Object],
      required: false,
    },
    name: {
      type: String,
      required: false
    },
    errors: {
      required: false,
      type: [Array, String],
      default: () => [],
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    providerRef: {
      required: false
    }
  },
  methods: {
    clearErrorsByName(name){
      if ('$_form_page' in this.$store._modules.root._children) this.$store.commit('$_form_page/CLEAR_ERRORS_BY_NAME', name);
    },
    async validateInput(e) {
      if (!this.providerRef) {
        return;
      }
      await this.providerRef.validate(e);
    }
  },
  computed: {
    errorsObject(){
      if ('$_form_page' in this.$store._modules.root._children) {
        return this.$store.getters['$_form_page/errorsObject'];
      }
    },
    isRequired() {
      if (!this.rules) return false;
      return this.rules.includes('required');
    },
    // Merge the response errors with vee validate errors.
    allErrors() {
      let serverErrors = [];
      if(this.errorsObject && this.name in this.errorsObject) {
        serverErrors = this.errorsObject[this.name];
      }
      return [...serverErrors, ...this.errors];
    }
  },
  watch: {
    value() {
      this.clearErrorsByName(this.name);
    }
  },
}
</script>

